import { Box, Typography, Container, Grid, Paper } from '@mui/material';
import { motion } from 'framer-motion';
import { Public, Business, People, WhatsApp } from '@mui/icons-material';

const GlobalStats = () => {
  const stats = [
    { icon: <Public />, value: '40+', label: 'Countries', color: '#C8A96B' },
    { icon: <Business />, value: '15+', label: 'Business Ventures', color: '#C8A96B' },
    { icon: <People />, value: '1000+', label: 'Partners Worldwide', color: '#C8A96B' },
    { icon: <WhatsApp />, value: '24/7', label: 'Direct Access', color: '#C8A96B' },
  ];

  return (
    <Box sx={{ py: 15, background: '#0B0B0B' }}>
      <Container maxWidth="lg">
        <Typography
          variant="subtitle1"
          sx={{ color: '#C8A96B', letterSpacing: 4, mb: 2, textAlign: 'center' }}
        >
          GLOBAL IMPACT
        </Typography>

        <Typography
          variant="h2"
          sx={{
            textAlign: 'center',
            mb: 8,
            fontSize: { xs: '2rem', md: '3rem' },
          }}
        >
          Worldwide Reach
        </Typography>

        <Grid container spacing={4}>
          {stats.map((stat, index) => (
            <Grid item xs={12} sm={6} md={3} key={index}>
              <motion.div
                initial={{ opacity: 0, scale: 0.8 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ delay: index * 0.1, duration: 0.5 }}
              >
                <Paper
                  sx={{
                    p: 4,
                    textAlign: 'center',
                    background: '#111',
                    border: '1px solid rgba(200,169,107,0.2)',
                    transition: 'all 0.3s',
                    '&:hover': {
                      borderColor: '#C8A96B',
                      transform: 'translateY(-5px)',
                    },
                  }}
                >
                  <Box sx={{ color: stat.color, fontSize: 48, mb: 2 }}>
                    {stat.icon}
                  </Box>
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 800,
                      mb: 1,
                      background: 'linear-gradient(135deg, #C8A96B, #E8D5A8)',
                      backgroundClip: 'text',
                      WebkitBackgroundClip: 'text',
                      color: 'transparent',
                    }}
                  >
                    {stat.value}
                  </Typography>
                  <Typography variant="body1" sx={{ color: '#999', fontWeight: 500 }}>
                    {stat.label}
                  </Typography>
                </Paper>
              </motion.div>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default GlobalStats;